import request from '@/utils/request'

/**
 * 通过业务服务器代传到 OSS（Bucket 未开 CORS 时浏览器无法直传）
 * @param {File} file
 * @param {string} type annexpic | attendancepic 等
 * @returns {Promise<{name:string,fileId:string,url:string,objectKey?:string,uploadRecordId?:string}>}
 */
export function ossUploadFile(file, type = 'annexpic') {
  if (!file) {
    return Promise.reject(new Error('请选择图片'))
  }
  const formData = new FormData()
  formData.append('file', file)
  const uploadType = type || 'annexpic'
  return request({
    url: '/api/Extend/OssDirectUpload/Upload?type=' + encodeURIComponent(uploadType),
    method: 'post',
    data: formData,
    timeout: 120000
  }).then(res => {
    const d = res && res.data
    if (!d || !d.url) {
      return Promise.reject(new Error('上传成功但未返回图片地址'))
    }
    return d
  })
}
